<template>
  <v-container fluid fill-height class="background-main">
    <v-layout align-center justify-center>
      <v-flex sm12 md8 lg6>
        <loginform/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import loginform from '@/components/login'
export default {
  data: () => ({
    valid: true,
    showeye: false,
    loger: null,
    session: {}
  }),
  components: { loginform },
  methods: {},
  computed: {},
  watch: {}
}
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,800");
.background-main {
  background-color: #026270;
  /* border-radius: 10px; */
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  overflow: hidden;
  max-width: 100%;
  min-height: 680px;
}
</style>
